var map = {
	"./1x1.png": 9882,
	"./MKVY__logo__black_whitebg.png": 4638,
	"./MMKYA_logoblock_533x218_v2_white.png": 9146,
	"./TB24_banner_300x150-01.svg": 2253,
	"./TB24_square_banner_300x150.png": 6323,
	"./menu_md.png": 6509,
	"./mibf.2021.plan.jpg": 3480,
	"./mibf_2019_512x512.png": 6074,
	"./mibf_2019_site.png": 2509,
	"./mibf_201_512x512.png": 8101,
	"./mibf_2021_site.png": 6738,
	"./red_square_2019_site.png": 3774,
	"./red_square_2023_logo_300x146.png": 4922,
	"./red_square_sign_2020.png": 7282,
	"./red_square_sign_2020_300px.png": 5708,
	"./red_square_sign_2021_300px.png": 3133,
	"./red_square_sign_2022_300px.png": 4658,
	"./reds.2021.plan.jpg": 8330,
	"./reds.2021.plan.png": 9070,
	"./reds.2022.plan.jpg": 1807,
	"./reds.2022.plan.legend.jpg": 8370,
	"./reds.2022.plan.map.jpg": 43,
	"./reds.2023.plan.jpg": 2824,
	"./reds.2023.plan.land.jpg": 9403,
	"./reds_square_2021.png": 9228,
	"./tobolsk.2023.logo.png": 2714,
	"./tobolsk.2023.logo_01.png": 8446,
	"./tobolsk.2023.plan.jpg": 3234,
	"./tobolsk.2023.plan.land.jpg": 9833,
	"./tobolsk.2024.logo.png": 7019,
	"./tobolsk.2024.logo_01.png": 933,
	"./tobolsk.2024.plan.jpg": 2027,
	"./tobolsk.2024.plan.land.jpg": 3238,
	"./tobolsk.2024.residence.logo.png": 9405,
	"./tobolsk.banner.bottom.png": 9773
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 569;